import Subject from "../cse4sub/Subject";
import React from 'react'

export default function MofpLab() {
  return (
    <div>
       <Subject title="Mechanical Operation in Food Processing Lab(AE408)" book1=" " book2=" "
    book1Link="#" book2Link="#" int21="#" mid21="#" end21="#"
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}